import PropTypes from "prop-types";
import React, { Component } from "react";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Chip from "@material-ui/core/Chip";
import SendIcon from "@material-ui/icons/Send";
import PopupWindow from "./popups/PopupWindow";
import EmojiPicker from "./emoji-picker/EmojiPicker";
import Recorder from "./Recorder";
import ReactDOMServer from "react-dom/server";
import { getSuggestions, clearSuggestions } from "../../../../../redux/actions/suggestionsActions";
import { fetchSkill } from "../../../../../redux/actions/skillActions";
import _ from "lodash";
import { connect } from "react-redux";
import Suggestions from "../../../../../components/SuggestAsYouType/Suggestions";
import { isUpperCase, ARROW_KEYS, DELETION_KEYS, replaceLastOccurrenceInString  } from "../../../../../utils";
import { SAYT_ENDPOINT_PREFIX } from "../../../../../constants";

class UserInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputActive: false,
      inputHasText: false,
      emojiPickerIsOpen: false,
      emojiFilter: "",
      lastUserRequestIndex: -1,
      historyMessage: null,
      readFromHistory: false,
      suggestionsPopperShown: false,
      suggestionsPopperAnchorEl: null,
      suggestionsModeActive: false,
      prefixToMatch: "",
      inputTextContent: "",
      contentBeforeSuggestionPrefix: "",
      activeIndex: 0
    };

    this.keysThatDontTriggerSuggestions = [
      ...ARROW_KEYS,
      /* ...DELETION_KEYS, */
      20, // Caps lock
      13, // Enter
      16, // Shift
      17, // Control
      18, // Alt
      225 // Right Alt
    ];
    this.keysThatDisableSuggestionMode = [
      27 // Esc key
    ];

    
  }

  componentDidMount() {
    this.emojiPickerButton = document.querySelector("#sc-emoji-picker-button");
  }


  getSuggestionColor = suggestionType => {
    switch (suggestionType) {
      case "Account":
      case "Author":
        // Blue
        return "#29B6F6";
      case "Opportunity":
        // Green
        return "#66BB6A";
      case "Lead":
        // Orange
        return "#FFCA28";
      case "Contact":
        // Purple
        return "#B39DDB";
      default:
        // Gray
        return "#9E9E9E";
    }
  };


  /**
   * This function exists because Element.closest() returned an error when called on a node taken from
   * window.getSelection().
   */
  getSuggestionAncestorNode = (el, currentLevel = 0, maxLevel = 5) => {
    const suggestionDataAttribute = "data-responsum-role";
    const suggestionDataAttributeValue = "suggestion";

    const parentNode = el.parentNode;

    if (!parentNode) {
      return null;
    }

    // Check if parent node is a suggestion node
    if (parentNode.getAttribute && parentNode.getAttribute(suggestionDataAttribute) === suggestionDataAttributeValue) {
      return parentNode;
    }

    if (currentLevel >= maxLevel) {
      return null;
    }

    return this.getSuggestionAncestorNode(parentNode, currentLevel + 1);
  };

  disableSuggestionsMode = (returnUpdateObj = false) => {
    const stateUpdateObj = {
      suggestionsModeActive: false,
      prefixToMatch: "",
      contentBeforeSuggestionPrefix: ""
    };

    if (returnUpdateObj) {
      return stateUpdateObj;
    }

    this.setState(stateUpdateObj);
  };

  getSuggestionChip = (text, suggestionType) => {
    return (
      <React.Fragment>
        <Chip
          data-responsum-role="suggestion"
          label={text}
          style={{ backgroundColor: this.getSuggestionColor(suggestionType) }}
        />{" "}
      </React.Fragment>
    );
  };

  addSuggestionIntoParent = (suggestion, suggestionType) => {
    this.userInput.innerHTML = replaceLastOccurrenceInString(
      this.userInput.innerHTML,
      this.state.suggestionSource,
      ReactDOMServer.renderToStaticMarkup(this.getSuggestionChip(suggestion, suggestionType))
    );
  };

  handleKeyDown(event) {
    const {suggestions} = this.props;
    const {activeIndex} = this.state;
    if(event.keyCode === 13 && this.state.suggestionsModeActive){
      event.preventDefault();
      this.addSuggestionIntoParent(suggestions[activeIndex].name, suggestions[activeIndex].type);
      this.resetSuggestionsState();
      this.disableSuggestionsMode();
      this.moveCursorToEnd(this.userInput)
    }else if(event.keyCode === 13 && !event.shiftKey) {
      this.setState({ lastUserRequestIndex: -1 });
      return this._submitText(event);
    }
  }

  constructMessage = (event, userHistory, callback) => {
    const {activeIndex, suggestions} = this.state;
    let index;
    // Check for up or down arrow
    if ([38, 40].indexOf(event.keyCode) >= 0 && !this.state.suggestionsModeActive) {
      index = -1;
      // Check for up arrow
      if (event.keyCode === 38) {
        if (this.state.lastUserRequestIndex + 1 < userHistory.length) {
          index = this.state.lastUserRequestIndex + 1;
        }
      } else if (event.keyCode === 40) {
        // Check for down arrow
        if (this.state.lastUserRequestIndex > 0) {
          index = this.state.lastUserRequestIndex - 1;
        }
      }
      this.setState({ lastUserRequestIndex: index }, () => {
        callback({ flg: true, message: index === -1 ? "" : userHistory[index].data.text, readFromHistory: true });
      });
    } else if(this.state.suggestionsModeActive){
      if (event.keyCode === 38 && activeIndex>0) {
        this.setState(prevState => ({activeIndex: prevState.activeIndex-1}))
      } else if (event.keyCode === 40 && activeIndex<9) {
        this.setState(prevState => ({activeIndex: prevState.activeIndex+1}))
      }
    } else {
      callback({
        flg: event.target.innerHTML.length !== 0 && event.target.innerText !== "\n",
        message: null,
        readFromHistory: false
      });
    }
  };

  canEnableSuggestionMode = (textContent, lastChar) => {
    const secondToLastChar = textContent.slice(-2, -1);
    return isUpperCase(lastChar) && (textContent === lastChar || /^\s$/g.test(secondToLastChar));
  };

  /*
   * Note that suggestions are only available if the user is typing at the end of the input.
   */
  checkForSuggestions = (userInput, suggestionsEndpoint) => {
    const { suggestionsModeActive, inputTextContent, contentBeforeSuggestionPrefix } = this.state;
    const { suggestions, getSuggestions } = this.props;
    let stateUpdate = {};
    let newPrefixToMatch;

    const textContent = userInput.textContent;

    if (!textContent || textContent.length === 0) {
      return {};
    }

    if (textContent === inputTextContent) {
      // Avoid going further down the function when there's no content change
      return {};
    }

    const lastChar = textContent.slice(-1);

    if (suggestionsModeActive) {

      if (/^\s$/g.test(lastChar) && suggestions.length === 0) {
        // Exit suggestion mode after the previous word returned no matches.
        // E.g. if the full input is "what is Yyy Maui ji" we want to match just "Maui ji" (not "Yyy Maui ji")
        return this.disableSuggestionsMode(true);
      }

      if (contentBeforeSuggestionPrefix === "") {
        // Case when suggestion mode was entered at the start of the input
        newPrefixToMatch = textContent;
      } else {
        const parts = textContent.split(new RegExp(`^${_.escapeRegExp(contentBeforeSuggestionPrefix)}`));
        newPrefixToMatch = parts.length > 1 ? parts[1] : "";
      }

      stateUpdate = {
        prefixToMatch: newPrefixToMatch,
        inputTextContent: textContent
      };
    }

    if (!suggestionsModeActive && this.canEnableSuggestionMode(textContent, lastChar)) {
      newPrefixToMatch = lastChar;

      stateUpdate = {
        suggestionsModeActive: true,
        inputTextContent: textContent,
        prefixToMatch: newPrefixToMatch,
        contentBeforeSuggestionPrefix: textContent.slice(0, -1)
      };
    }

    if (newPrefixToMatch && newPrefixToMatch.length > 1) {
      getSuggestions(newPrefixToMatch, suggestionsEndpoint);
      stateUpdate = { ...stateUpdate, suggestionSource: newPrefixToMatch, suggestionsPopperShown: true };
    }

    return stateUpdate;
  };

  checkIfCursorIsInSuggestionNode = () => {
    const sel = window.getSelection();

    if (!sel) {
      return null;
    }

    return this.getSuggestionAncestorNode(sel.anchorNode);
  };

  deleteSuggestionNode = suggestionNode => {
    if (!suggestionNode) {
      return;
    }

    const nextSiblingOfSuggestionNode = suggestionNode.nextSibling;
    suggestionNode.remove();

    // Check if there's a space after the suggestion node
    if (
      nextSiblingOfSuggestionNode &&
      nextSiblingOfSuggestionNode.nodeType === Node.TEXT_NODE &&
      nextSiblingOfSuggestionNode.textContent === " "
    ) {
      // Delete space char next to the suggestion since a space is inserted along the suggestion in
      // the Suggestions component.
      // If a suggestion was inserted at the end of the input and the user deleted it with the delete key,
      // there would be a space left.
      // The user might not notice the space and no suggestions would be shown since the text is not
      // inserted at the end of the input.
      nextSiblingOfSuggestionNode.remove();
    }
  };

  /**
   * Handle suggestions behaviour after a key is typed.
   */
  handleSuggestions = keyCode => {
    const suggestionsEndpoint = this.getSuggestionsEndpoint();
    if (!suggestionsEndpoint) {
      return;
    }
   
    if (!this.keysThatDontTriggerSuggestions.includes(keyCode)) {
      let suggestionStateUpdates = {};
      let resp;

      this.resetSuggestionsState();
      this.setSuggestionsPopperAnchorEl();

      if (this.keysThatDisableSuggestionMode.includes(keyCode)) {
        resp = this.disableSuggestionsMode(true);
      } else {
        resp = this.checkForSuggestions(this.userInput, suggestionsEndpoint);
      }

      suggestionStateUpdates = { ...suggestionStateUpdates, ...resp };

      this.setState(suggestionStateUpdates);
    }

    // Check if a deletion key was typed
    /* if (DELETION_KEYS.includes(keyCode)) {
      const suggestionNode = this.checkIfCursorIsInSuggestionNode();

      if (suggestionNode) {
        this.deleteSuggestionNode(suggestionNode);
      }

      this.resetSuggestionsState();
      this.disableSuggestionsMode(); 
      console.log("disable cause of keys")

    } */
  };

  getSuggestionsEndpoint = () => {
    const { skill } = this.props;

    if (!skill || _.isEmpty(skill)) {
      // Need the skill the get the tenant from it. Need the tenant to get the suggestions endpoint.
      fetchSkill();
      return undefined;
    }

    const tenant = _.get(skill, "tenant", undefined);

    if (!tenant) {
      return undefined;
    }

    return _.get(SAYT_ENDPOINT_PREFIX, tenant, undefined);
  };

  async handleKeyUp(event) {
    
    this.handleSuggestions(event.keyCode);

    const userHistory = this.props.allTimeUserHistory;

    this.constructMessage(event, userHistory, result => {
      this.setState({
        inputHasText: result.flg,
        historyMessage: result.message,
        readFromHistory: result.readFromHistory
      });
    });
  }

  _showFilePicker() {
    this._fileUploadButton.click();
  }

  toggleEmojiPicker = e => {
    e.preventDefault();
    if (!this.state.emojiPickerIsOpen) {
      this.setState({ emojiPickerIsOpen: true });
    }
  };

  closeEmojiPicker = e => {
    if (this.emojiPickerButton.contains(e.target)) {
      e.stopPropagation();
      e.preventDefault();
    }
    this.setState({ emojiPickerIsOpen: false });
  };

  // cleans the formatting when pasting text, ex: when copying message from chat, it doesn't have blue background
  pasteText = e => {
    e.preventDefault();
    var text = (e.originalEvent || e).clipboardData.getData("text/plain");
    document.execCommand("insertHTML", false, text);
  };

  _submitText(event) {
    event.preventDefault();
    const text = this.userInput.textContent;
    if (text && text.length > 0) {
      this.props.onSubmit({
        author: "me",
        type: "text",
        data: { text }
      });
      this.userInput.innerHTML = "";
    }
  }

  _submitGoogleText(text) {
    if (text && text.length > 0) {
      this.props.onSubmit({
        author: "me",
        type: "transcript",
        data: { text }
      });
    }
  }

  _submitVoice(audio) {
    this.props.onSubmit({
      author: "me",
      type: "voice",
      data: { audio }
    });
  }

  _onFilesSelected(event) {
    if (event.target.files && event.target.files.length > 0) {
      this.props.onFilesSelected(event.target.files);
    }
  }

  _handleEmojiPicked = emoji => {
    this.setState({ emojiPickerIsOpen: false });
    if (this.state.inputHasText) {
      this.userInput.innerHTML += emoji;
    } else {
      this.props.onSubmit({
        author: "me",
        type: "emoji",
        data: { emoji }
      });
    }
  };

  handleEmojiFilterChange = event => {
    const emojiFilter = event.target.value;
    this.setState({ emojiFilter });
  };

  _renderEmojiPopup = () => (
    <PopupWindow
      isOpen={this.state.emojiPickerIsOpen}
      onClickedOutside={this.closeEmojiPicker}
      onInputChange={this.handleEmojiFilterChange}
    >
      <EmojiPicker onEmojiPicked={this._handleEmojiPicked} filter={this.state.emojiFilter} />
    </PopupWindow>
  );

  _renderSendOrFileIcon() {
    return (
      <Toolbar style={{ paddingRight: "8px", paddingLeft: 0 }}>
        <IconButton onClick={this._submitText.bind(this)}>
          <SendIcon />
        </IconButton>
        <Recorder
          submitVoice={this._submitVoice.bind(this)}
          submitText={this._submitGoogleText.bind(this)}
          playingState={this.props.playingState}
          onRecordingStateChange={this.props.onRecordingStateChange}
          listeningState={this.props.listeningState}
        />
      </Toolbar>
    );
  }
  /*return (
      <div className="sc-user-input--button">
        <FileIcon onClick={this._showFilePicker.bind(this)} />
        <input
          type="file"
          name="files[]"
          multiple
          ref={e => {
            this._fileUploadButton = e;
          }}
          onChange={this._onFilesSelected.bind(this)}
        />
      </div>
    );
  }*/
 
  resetSuggestionsState = () => {
    this.setState({
      suggestionSource: null,
      suggestionsPopperShown: false,
      activeIndex: 0
    });
    this.props.clearSuggestions();
  };

  setSuggestionsPopperAnchorEl = () => {
    const selection = window.getSelection();

    // Resets when text has been selected
    if (selection && selection.anchorOffset !== selection.focusOffset) {
      this.resetSuggestionsState();
      return;
    }

    const getBoundingClientRect = () => selection.getRangeAt(0).getBoundingClientRect();

    this.setState({
      suggestionsPopperAnchorEl: {
        clientWidth: getBoundingClientRect().width,
        clientHeight: getBoundingClientRect().height - 100,
        getBoundingClientRect
      }
    });
  };

  moveCursorToEnd = el => {
    const childNodes = el.childNodes;

    if (!childNodes || childNodes.length === 0) {
      return;
    }
    const lastNode = childNodes[childNodes.length - 1];
    const selection = window.getSelection();
    selection.removeAllRanges();
    const range = document.createRange();
    range.collapse(false);
    range.selectNode(el);
    range.setStartAfter(lastNode);
    range.setEndAfter(lastNode);

    selection.addRange(range);
  };

  renderPopper = () => {
    const { suggestionsPopperShown, suggestionsPopperAnchorEl, suggestionSource, activeIndex } = this.state;
    const { suggestions } = this.props;

    if (!suggestionsPopperShown || !suggestions || suggestions.length === 0) {
      return null;
    }

    return (
      <Suggestions
        shown={suggestionsPopperShown}
        anchorEl={suggestionsPopperAnchorEl}
        suggestions={suggestions}
        parent={this.userInput}
        suggestionsSource={suggestionSource}
        resetParentSuggestionsState={this.resetSuggestionsState}
        moveCursorToEndInParent={() => this.moveCursorToEnd(this.userInput)}
        disableSuggestionsMode={this.disableSuggestionsMode}
        activeIndex={activeIndex}
        getSuggestionChip={this.getSuggestionChip}
      />
    );
  };

  render() {
    const { inputActive } = this.state;

    return (
      <React.Fragment>
        <form className={`sc-user-input ${inputActive ? "active" : ""}`}>
          <div
            // type="text"
            role="button"
            tabIndex="0"
            onFocus={() => {
              this.setState({ inputActive: true });
            }}
            onBlur={() => {
              this.setState({ inputActive: false });
              this.resetSuggestionsState();
            }}
            ref={e => {
              if (!e) return;
              if (this.state.readFromHistory) {
                this.setState({ readFromHistory: false }, () => {
                  e.innerHTML = this.state.historyMessage;
                });
              }
              this.userInput = e;
            }}
            onKeyDown={this.handleKeyDown.bind(this)}
            onKeyUp={this.handleKeyUp.bind(this)}
            onPaste={this.pasteText}
            contentEditable="true"
            placeholder="Write a reply..."
            className="sc-user-input--text"
          />
          {this._renderSendOrFileIcon()}
        </form>
        {this.renderPopper()}
      </React.Fragment>
    );
  }
}

UserInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onFilesSelected: PropTypes.func.isRequired,
  showEmoji: PropTypes.bool
};

function mapStateToProps(state) {

  return {
    allTimeUserHistory: _.uniqBy(
      _.filter(
        _.filter(_.get(state, "chat.chatUserHistory.allTimeUserHistory", []), item => item.author === "me"),
        item => item.hidden !== true
      ).reverse(),
      "data.text"
    ),
    suggestions: state.suggestions.suggestions,
    skill: state.skill
  };
}

export default connect(
  mapStateToProps,
  { getSuggestions, clearSuggestions, fetchSkill }
)(UserInput);
